import request from '../../axios';

export interface IGetCalculateLoanParams {
  amount: number;
  total_repayment_time: number;
  repayment_interval: number;
  loan_rate: number;
}

export interface ICalculateLoanResponse {
  amount: number;
  final_loan_amount: number;
  installment_amount: number;
  loan_rate: number;
  profit_percentage: number;
  repayment_interval: number;
  total_profit_amount: number;
  total_repayment_time: number;
}

export interface IGetCalculateLoanParams {
  amount: number;
  total_repayment_time: number;
  repayment_interval: number;
  loan_rate: number;
}

const postCalculateLoan = async (params: IGetCalculateLoanParams) => {
  const {data}: {data: ICalculateLoanResponse} = await request.get(
    '/api/v2/payment/calculate-loan',
    {
      params,
    },
  );
  return data;
};
export default postCalculateLoan;
